export const DEFAULT_USER_NAME = 'System / Unknown User';

export const PLACEHOLDER_INSTRUCTIONS = `Custom Network Context is appended to the system prompt every time AI Advisor is invoked. This gives AI Advisor deeper knowledge of your infrastructure and procedures. Provide details about your network environment to help AI Advisor deliver more accurate and relevant insights.
Include information such as:
- Network design and architecture (campus, WAN, data center, cloud)
- Naming conventions for devices, interfaces, and sites
- IP addressing schema
- VLAN or VRF convention
- Device types and vendors
- Network segments and their purposes (e.g. Data Centers, WAN network, Campus network, etc.)
- Critical applications and traffic patterns
- Any specific operational procedures or constraints

For task specific instructions, use [Runbooks](https://kb.kentik.com/docs/kentik-ai#runbooks-pane) instead of Custom Network Context.`;
